import { AppDispatch, RootState } from "src/store/store";
import { Box, Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppRoutes } from "src/common/constants/constantEnums";
import ArrowLeft from "../../src/resources/icons/arrow-left-02.svg";
import { EnglishLabels } from "src/common/constants/englishLabels";
import { GlobalLangSelector } from "src/common/globalLangSelector";
import { GlobalUtils } from "src/utils/globalUtils";
import { HindiLabels } from "src/common/constants/hindiLabels";
import { MksLogo } from "../resources/icons";

export const Home = (): React.ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    GlobalUtils.setGlobalLanguage(dispatch);
  }, [dispatch]);

  useEffect(() => {
    const approved = (localStorage.getItem("approved") || "").toLowerCase() === "true";
    const pendingAccess = (localStorage.getItem("pendingAccess") || "").toLowerCase() === "true";
    if (!approved && pendingAccess) {
      // auto-logout on Home for pending users
      localStorage.removeItem("authToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("accountInfo");
      localStorage.removeItem("cachedSubmitDetails");
      localStorage.removeItem("pendingAccess");
    }
  }, []);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      height="100%"
      width="100%"
      overflow="auto"
    >
      <Box
        margin="2rem auto 2rem auto"
        width="90%"
        borderRadius="1.5rem"
        overflow="hidden"
      >
        <Image
          src="/mks_bg.png"
          alt="Community Image"
          objectFit="cover"
          width="100%"
          height="auto"
        />
      </Box>
      <Flex
        width="100%"  
        position="relative"
        direction="column"
        alignItems="center"
        px={{ base: "1rem", md: "0" }}
      >
        <Flex width="100%" paddingX="5%" justifyContent="space-between">
          <Link to="/" style={{ textDecoration: "none" }}>
            <Flex height="100%" alignItems="center" className="custom-link" fontWeight="medium">
                <Image paddingRight={2} src={ArrowLeft} height="24px" width="24px"/>
                {isHindiLabels
                ? HindiLabels.Back_to_Home
                : EnglishLabels.Back_to_Home}
            </Flex>
          </Link>
          <GlobalLangSelector />
        </Flex>
        <Flex direction="column" alignItems="center">
          <Box height="5rem" width="5rem">
            <MksLogo />
          </Box>
          <Heading
            color="#4A2C2A"
            fontWeight="700"
            fontSize={{ base: "1.875rem", sm: "2.25rem", md: "2.5rem" }}
            paddingX={2}
            letterSpacing="-1px"
            textAlign="center"
          >
            {isHindiLabels
              ? HindiLabels.Mourya_Community_Label
              : EnglishLabels.Mourya_Community_Label}
          </Heading>
          <Text textAlign="center" paddingX={2}>
            {isHindiLabels
              ? HindiLabels.Mourya_Community_Label2
              : EnglishLabels.Mourya_Community_Label2}
          </Text>
        </Flex>
      </Flex>
      <Flex
        mt="2rem"
        mb="2rem"
        px="1rem"
        gap="1rem"
        direction={{ base: "column", sm: "row" }}
        alignItems="center"
        justifyContent="center"
      >
          <Button
            width="8rem"
            mr="2rem"
            variant="mks-white"
            alignItems="center"
            onClick={() => navigate(AppRoutes.REGISTER, { state: { fromApp: true } })}
          >
            <Heading color="#4A2C2A" fontSize="large">
              {isHindiLabels ? HindiLabels.Register : EnglishLabels.Register}
            </Heading>
          </Button>
          <Button
            width="8rem"
            variant="mks"
            alignItems="center"
            onClick= {() => navigate(AppRoutes.LOGIN, { state: { fromApp: true } })}
          >
            <Heading color="white" fontSize="large">
              {isHindiLabels ? HindiLabels.Login : EnglishLabels.Login}
            </Heading>
          </Button>
      </Flex>
    </Flex>
  );
};
